import React from "react";

export default function BetaWarning() {
  // TODO : Bug dialog
  return (
    <div
      style={{
        position: "absolute",
        top: 4,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 100000,
        backgroundColor: "red",
        color: "#FFF",
        padding: "2px 8px",
        borderRadius: 4,
        userSelect: "none",
        pointerEvents: "none",
      }}
    >
      <div style={{ whiteSpace: "nowrap", fontSize: "1rem" }}>
        Version Beta ! Plus à venir bientôt !
      </div>
      <div style={{ cursor: "pointer", fontSize: "0.7rem", pointerEvents: "all" }}>
        Cliquez ici pour signaler un bug.
      </div>
    </div>
  );
}
